import FeedbackForm from '@/app/modules/_shared/modals/feedback-form/feedback-form.vue';

export default {
  components: { FeedbackForm },
  name: 'feedback-link',
  data: () => ({
    show: false,
  }),
  methods: {
    handleShow(event) {
      if (event) {
        event.preventDefault();
      }
      this.show = true;
    },
    handleClose() {
      this.show = false;
    },
  },
};
